'use client'

import { useMemo, useState } from 'react'
import { calcRoofing } from '@/lib/calculators/formulas'
import { ToolField, ToolResultCard, ToolResultRow, toolCurrency, toolFmt, toolNum } from './tool-inputs'

// 1 roofing "square" = 100 sq ft = 9.29 m².
const SQUARE_M2 = 9.290304

export function RoofingCalculatorTool() {
  const [length, setLength] = useState('10')
  const [width, setWidth] = useState('8')
  const [pitch, setPitch] = useState('22.5')
  const [tilesPerM2, setTilesPerM2] = useState('10')
  const [price, setPrice] = useState('12')

  const r = useMemo(() => {
    const planArea = toolNum(length) * toolNum(width)
    const coveragePerTile = toolNum(tilesPerM2) > 0 ? 1 / toolNum(tilesPerM2) : 0
    const { roofArea, unitsNeeded, materialCost } = calcRoofing(planArea, toolNum(pitch), coveragePerTile, toolNum(price))
    return { roofArea, squares: roofArea / SQUARE_M2, tiles: unitsNeeded, cost: materialCost }
  }, [length, width, pitch, tilesPerM2, price])

  return (
    <div className="grid gap-6 md:grid-cols-[1fr_380px] md:items-start">
      <div className="space-y-5 rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
        <div>
          <h2 className="text-sm font-semibold uppercase tracking-wide text-slate-500">Roof plan</h2>
          <div className="mt-3 grid grid-cols-3 gap-3">
            <ToolField label="Plan length" value={length} onChange={setLength} unit="m" />
            <ToolField label="Plan width" value={width} onChange={setWidth} unit="m" />
            <ToolField label="Pitch" value={pitch} onChange={setPitch} unit="°" hint="Roof angle" />
          </div>
        </div>
        <div>
          <h2 className="text-sm font-semibold uppercase tracking-wide text-slate-500">Tiles &amp; price</h2>
          <div className="mt-3 grid grid-cols-2 gap-3">
            <ToolField label="Tiles per m²" value={tilesPerM2} onChange={setTilesPerM2} unit="/m²" hint="~10 for concrete tile" />
            <ToolField label="Tile price" value={price} onChange={setPrice} unit="R/tile" />
          </div>
        </div>
      </div>

      <ToolResultCard title="Your roofing estimate">
        <ToolResultRow label="Pitched roof area" value={`${toolFmt(r.roofArea, 1)} m²`} />
        <ToolResultRow label="Roofing squares" value={`${toolFmt(r.squares, 1)} sq`} />
        <ToolResultRow label="Tiles to buy (incl. waste)" value={`${r.tiles} tiles`} />
        <ToolResultRow label="Estimated tile cost" value={toolCurrency(r.cost)} strong />
      </ToolResultCard>
    </div>
  )
}
